exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._21kHg{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._21kHg:hover{opacity:.7}.pYcDu{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._37yuv{z-index:10000;left:10px;overflow:scroll;width:400px;height:250px;border-radius:3px;background-color:rgba(0,0,0,.95)}._37yuv,._37yuv ._32rJ_{position:absolute;top:10px}._37yuv ._32rJ_{right:5px;cursor:pointer;color:#fff}._37yuv ._32rJ_:hover{opacity:.8}._37yuv ._1-ZcL{font-size:8px;line-height:8px;margin:5px;padding:5px;color:#fff}._37yuv ._1-ZcL .YAxnZ{color:green}._37yuv ._1-ZcL ._3_cSV{color:#ff8c00}._37yuv ._1-ZcL .nMwdY{color:blue}._37yuv ._1-ZcL ._3KjsN{color:#f0f}._37yuv ._1-ZcL ._3E3hj{color:#fff}", ""]);

// exports
exports.locals = {
	"controlButton": "_21kHg",
	"hidden": "pYcDu",
	"debugPanel": "_37yuv",
	"closeButton": "_32rJ_",
	"infoContainer": "_1-ZcL",
	"string": "YAxnZ",
	"number": "_3_cSV",
	"boolean": "nMwdY",
	"null": "_3KjsN",
	"key": "_3E3hj"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--9-1!../node_modules/postcss-loader/lib??ref--9-2!../node_modules/sass-loader/lib/loader.js??ref--9-3!./default-modules/ui/debug-panel/debug-panel.scss
// module id = 129
// module chunks = 0 1 2 3 4